module.exports = __webpack_public_path__ + "static/find-rehab-img-f4907bd9b024229ed9400eabfdc4e95d.png";